import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Radio, RadioGroup } from '@/components/atoms/RadioGroup';

import styles from './FishHealthFilter.module.scss';

interface FishHealthFilterProps {
    onFilterGroupChange?: (filterState: string) => void;
    filterStateList?: { title: string; tag: string }[];
    disableRadioList?: boolean[];
    currentFilterStateList?: string;
}

function FishHealthFilter({
    filterStateList = [],
    onFilterGroupChange,
    disableRadioList = [],
    currentFilterStateList,
}: FishHealthFilterProps) {
    const { t } = useTranslation();
    const [filterState, setFilterState] = useState(
        currentFilterStateList ? currentFilterStateList : (filterStateList[0]?.tag ?? '')
    );

    const filterChangeHandler = (value: string): void => {
        setFilterState(value);
        onFilterGroupChange?.(value);
    };

    useEffect(() => {
        if (currentFilterStateList) {
            setFilterState(currentFilterStateList);
        } else {
            setFilterState(filterStateList[0]?.tag ?? '');
        }
    }, [filterStateList]);

    return (
        <div className={styles.fishhealthfilter}>
            <RadioGroup
                className={styles.group}
                direction="horizontal"
                name="fish_filter"
                value={filterState}
                onValueChange={filterChangeHandler}>
                {filterStateList.map((filterStateItem, index) => (
                    <Radio
                        key={filterStateItem.tag}
                        id={filterStateItem.tag}
                        value={filterStateItem.tag}
                        label={t(filterStateItem.title)}
                        labelClassName={styles.option}
                        disabled={disableRadioList[index] ?? false}
                    />
                ))}
            </RadioGroup>
        </div>
    );
}

export default FishHealthFilter;
export { FishHealthFilter };
